import { useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import { selectHasSummarizationSettingsPermission } from '../../permissions';
import { selectIsSummarizationMailForParticipants } from '../selectors';

interface CheckboxState {
    checked: boolean;
    disabled: boolean;
}
type SettableCheckboxState = Partial<Pick<CheckboxState, 'checked'>>;

type SetCheckboxState = (state: SettableCheckboxState) => void;

export function useSummarizationMailRecipientCheckboxState(): [CheckboxState, SetCheckboxState] {
    const isSummarizationMailForParticipants = useSelector(selectIsSummarizationMailForParticipants);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);

    const [desiredIsSummarizationMailForParticipants, setDesiredIsSummarizationMailForParticipants] = useState(
        isSummarizationMailForParticipants
    );

    const state: CheckboxState = {
        checked: Boolean(desiredIsSummarizationMailForParticipants),
        disabled: !hasSummarizationSettingsPermission,
    };

    const setState = useCallback(({ checked } = {}) => {
        if (checked !== undefined) {
            setDesiredIsSummarizationMailForParticipants(checked);
        }
    }, []);

    return [state, setState];
}
